import { render, staticRenderFns } from "./CounterpartsRankingCard.vue?vue&type=template&id=40a1b782&scoped=true"
import script from "./CounterpartsRankingCard.vue?vue&type=script&lang=js"
export * from "./CounterpartsRankingCard.vue?vue&type=script&lang=js"
import style0 from "./CounterpartsRankingCard.vue?vue&type=style&index=0&id=40a1b782&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a1b782",
  null
  
)

export default component.exports